module.exports = __webpack_public_path__ + "static/cover-4cd958874d5e871cca67162943ee525c.mp4";